const STORAGE_KEY = 'funpaper.guestSecret';
const GUEST_SECRET_REGEX = /^[a-zA-Z0-9_-]{32,128}$/;
let memorySecret: string | null = null;

function generateSecret(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${crypto.randomUUID()}${crypto.randomUUID()}`.replace(/-/g, '');
  }
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const bytes = new Uint8Array(32);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  }
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`
    .repeat(4)
    .slice(0, 64);
}

export function getOrCreateGuestSecret(): string {
  if (typeof localStorage !== 'undefined') {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing && GUEST_SECRET_REGEX.test(existing)) return existing;
    const secret = generateSecret();
    try {
      localStorage.setItem(STORAGE_KEY, secret);
    } catch {
      memorySecret = secret;
    }
    return secret;
  }
  memorySecret ??= generateSecret();
  return memorySecret;
}
